import Notify from 'simple-notify';
import 'simple-notify/dist/simple-notify.min.css';

const DEFAULT_OPTIONS: any = {
  effect: 'fade',
  speed: 300,
  customClass: '',
  customIcon: '',
  showIcon: true,
  showCloseButton: true,
  autoclose: true,
  autotimeout: 3000,
  gap: 20,
  distance: 20,
  type: 3,
  position: 'right top',
};

export function error(options: any) {
  if (typeof options === 'string') {
    options = { title: options };
  }

  return new Notify({
    ...DEFAULT_OPTIONS,
    status: 'error',
    ...options,
  });
}

export function success(options: any) {
  if (typeof options === 'string') {
    options = { title: options };
  }

  return new Notify({
    ...DEFAULT_OPTIONS,
    status: 'success',
    ...options,
  });
}

export function warning(options: any) {
  if (typeof options === 'string') {
    options = { title: options };
  }

  return new Notify({
    ...DEFAULT_OPTIONS,
    status: 'warning',
    ...options,
  });
}
